// Реализует необходимую функциональность при прокрутке вкладок на странице поиска
// (показывает/скрывает элемент размытия слева и справа от вкладок, управляет автоматической прокруткой к нужной вкладке)
(function () {
    'use strict';

    let tabs;
    let tabsRect;
    let tabsWrapperScroll;
    let tabsWrapperScrollRect;
    let tabsWrapperScrollWidth;
    let discolorationLeft;
    let discolorationLeftRect;
    let discolorationRight;
    let discolorationRightRect;
    let scrollMax = 0;
    let touchStartX = 0;
    let prevTouchMoveX = 0;

    document.addEventListener('DOMContentLoaded', () => {
        tabs = document.querySelector('.filter__tabs');
        tabsWrapperScroll = document.querySelector('.filter__tabs-wrapper-scroll');

        initElementDiscolorationLeft();

        determineTabsPositionAndSize();

        scrollToActiveTab();

        document.addEventListener('tab-is-selected', onTabIsSelected);
        window.addEventListener('orientationchange', onOrientationOrSizeChange, false);
        window.addEventListener('resize', onOrientationOrSizeChange, false);

        if (isFirefox()) {
            activeJsScroll();
        } else {
            tabsWrapperScroll.addEventListener('scroll', onScroll);
        }
    });

    /**
     * Инициализация элемента
     *
     */
    function initElementDiscolorationLeft() {
        discolorationLeft = document.querySelector('.js-discoloration-left');
        discolorationLeft.style.display = 'block';
        discolorationLeftRect = discolorationLeft.getBoundingClientRect();
        discolorationLeft.style.display = '';

        discolorationRight = document.querySelector('.js-discoloration-right');
        discolorationRight.style.display = 'block';
        discolorationRightRect = discolorationRight.getBoundingClientRect();
        discolorationRight.style.display = '';
    }

    /**
     * Определяет позицию и размер блока содержащего список влкадок
     *
     */
    function determineTabsPositionAndSize() {
        tabsRect = tabs.getBoundingClientRect();
        tabsWrapperScrollRect = tabsWrapperScroll.getBoundingClientRect();
        tabsWrapperScrollWidth = getElementInnerWidth(tabsWrapperScroll);

        scrollMax = tabsRect.width - tabsWrapperScrollRect.width;
    }

    /**
     * Активирует скролл работающий с помощью Js
     *
     */
    function activeJsScroll() {
        tabs.setAttribute('data-x', '0');
        tabsWrapperScroll.style.overflowX = 'hidden';

        tabsWrapperScroll.addEventListener('touchstart', onTabsWrapperScrollTouchStart, {passive: true});
        tabsWrapperScroll.addEventListener('touchend', onTabsWrapperScrollTouchEnd);
    }

    /**
     * Производит прокрутку к активной вкладке
     *
     */
    function scrollToActiveTab() {
        scrollToTab(getActiveTab());
    }

    /**
     * Производит прокрутку к указанной вкладке
     *
     * @param {HTMLElement} elementTab
     *
     */
    function scrollToTab(elementTab) {
        if (!elementTab) {
            return;
        }

        if (!isVisibleDiscoloration()) {
            return;
        }

        showDiscoloration('left', !isUnderDiscoloration(elementTab, discolorationLeftRect));
        showDiscoloration('right', !isUnderDiscoloration(elementTab, discolorationRightRect));

        let tabWidth = getElementInnerWidth(elementTab);
        let tabLeft = elementTab.getBoundingClientRect().left;

        if (tabLeft <= 2) {
            scrollTo(tabsWrapperScroll, tabsWrapperScroll.scrollLeft - tabWidth, 400);
        } else if ((tabLeft + tabWidth) >= tabsWrapperScrollWidth) {
            scrollTo(tabsWrapperScroll, (tabLeft + tabWidth + tabsWrapperScroll.scrollLeft + (tabsWrapperScrollWidth / 5)) - tabsWrapperScrollWidth, 400);
        }
    }

    /**
     * Производит прокрутку
     *
     * @param {HTMLElement} element Ссылка на элемент
     * @param {Number} to Координата X
     * @param {Number} duration Длительность
     *
     */
    function scrollTo(element, to, duration) {
        if (duration <= 0) {
            element.scrollLeft = to;
            return;
        }

        let difference = to - element.scrollLeft;
        let perTick = difference / duration * 10;

        let step = function () {
            element.scrollLeft += perTick;
            if (((element.scrollLeft >= to) && difference >= 0) || ((element.scrollLeft <= to) && difference <= 0)) {
                element.scrollLeft = to;
                return;
            }

            scrollTo(element, to, duration - 10);
        };

        if (window.requestAnimationFrame) {
            requestAnimationFrame(step);
        } else {
            setTimeout(step, 10);
        }
    }

    /**
     * Определяет отображается или нет элемент отображающий эффект выцветания.
     * Таким способом просто определяем desktop это или mobile.
     * @return {Boolean}
     */
    function isVisibleDiscoloration() {
        let element = document.querySelector('.js-discoloration-right');
        if (!element) {
            return false;
        }

        return (getComputedStyle(element).display !== 'none');
    }

    /**
     * Определяет находится ли указанный элемент под блоком выцветания
     *
     * @param {HTMLElement} element
     * @param {Object} elementDiscolorationPosition
     *
     * @return {Boolean}
     */
    function isUnderDiscoloration(element, elementDiscolorationPosition) {
        if (!element) {
            return false;
        }

        let elementRect = element.getBoundingClientRect();

        return (inRange(elementDiscolorationPosition.left, elementRect.left, elementRect.left + elementRect.width)
        || inRange(elementDiscolorationPosition.right, elementRect.left, elementRect.left + elementRect.width));
    }

    /**
     * Отображает/скрывает элемент отображающий эффект выцветания
     *
     * @param {String} position
     * @param {Boolean} show
     *
     */
    function showDiscoloration(position, show) {
        let element = position === 'left' ? discolorationLeft : discolorationRight;
        if (!element) {
            return false;
        }

        if (show) {
            element.classList.remove('is-hidden');
        } else {
            element.classList.add('is-hidden');
        }
    }

    /**
     * Автоматически определяет нужно или нет отображать элемент отображающий эффект выцветания
     *
     */
    function autoShowDiscoloration() {
        showDiscoloration('left', !isUnderDiscoloration(getActiveTab(), discolorationLeftRect));
        showDiscoloration('right', !isUnderDiscoloration(getActiveTab(), discolorationRightRect));
    }

    /**
     * Возвращает ссылку на элемент активной вкладки
     *
     * @return {HTMLElement}
     */
    function getActiveTab() {
        return document.querySelector('.filter__tab.active');
    }

    /**
     * Возвращает ширину элемента
     *
     * @param {HTMLElement} element
     *
     * @return {Number}
     */
    function getElementInnerWidth(element) {
        let computedStyle = getComputedStyle(element);

        return element.offsetWidth
            - parseInt(computedStyle.paddingLeft, 10)
            - parseInt(computedStyle.paddingRight, 10);
    }

    /**
     * Определяет является ли текущий бразуер Firefox-ом
     *
     * @return {Boolean}
     */
    function isFirefox() {
        return ((typeof InstallTrigger !== 'undefined') || (navigator.userAgent.toLowerCase().indexOf('firefox') > -1));
    }

    /**
     * Определяет входит ли указанно значение в диапахон
     *
     * @return {Boolean}
     */
    function inRange(value, from, to) {
        return ((value >= from) && (value <= to));
    }

    /**
     * Обработчик события: начало касания
     *
     */
    function onTabsWrapperScrollTouchStart(evt) {
        touchStartX = evt.changedTouches[0].clientX;
        prevTouchMoveX = touchStartX;

        tabsWrapperScroll.addEventListener('touchmove', onTabsWrapperScrollTouchMove);
    }

    /**
     * Обработчик события: окончания касания
     *
     */
    function onTabsWrapperScrollTouchEnd() {
        tabsWrapperScroll.removeEventListener('touchmove', onTabsWrapperScrollTouchMove);
    }

    /**
     * Обработчик события: перемещение указателя
     *
     */
    function onTabsWrapperScrollTouchMove(evt) {
        let touch = evt.changedTouches[0];
        let positionX = touch.clientX;
        let scrollOffset = prevTouchMoveX - positionX;
        let currPositionX = parseInt(tabs.getAttribute('data-x'), 10);
        let newPositionX = currPositionX - scrollOffset;

        prevTouchMoveX = positionX;

        if ((newPositionX < 0) && (scrollMax <= Math.abs(newPositionX))) {
            newPositionX = -scrollMax;
        } else if (newPositionX > 0) {
            newPositionX = 0;
        }

        if (newPositionX === currPositionX) {
            return;
        }

        tabs.style.transform = 'translate3d(' + newPositionX + 'px, 0px, 0px)';
        tabs.setAttribute('data-x', String(newPositionX));

        autoShowDiscoloration();
    }

    /**
     * Обработчик события: выбрана вкладка
     *
     */
    function onTabIsSelected() {
        scrollToTab(getActiveTab());
    }

    /**
     * Обработчик события: изменение ориентации страницы или изменения размера
     *
     */
    function onOrientationOrSizeChange() {
        determineTabsPositionAndSize();
        scrollToActiveTab();
    }

    function onScroll() {
        if (window.requestAnimationFrame) {
            requestAnimationFrame(autoShowDiscoloration);
        } else {
            setTimeout(autoShowDiscoloration, 60);
        }

    }
})();